import React from 'react';
import IconCar from '@spothero/icons/car';
import IconCoveredSpot from '@spothero/icons/car-covered-filled';
import IconCurbsideDropoff from '@spothero/icons/curbside-dropoff';
import IconMarker from '@spothero/icons/pin';
import IconPublicTransit from '@spothero/icons/train-filled';
import IconShuttle from '@spothero/icons/bus';
import IconUncoveredSpot from '@spothero/icons/car-filled';
import { parseDistance } from 'utils/travel-distance';
const DEFAULT = 'default';
const TAXI = 'taxi';
const CURBSIDE_VALET = 'curbside-valet';
const ON_DEMAND = 'on-demand';
const PUBLIC_TRANSIT = 'public-transit';
const SHUTTLE_CONFIG = {
    [DEFAULT]: {
        shuttleIcon: IconShuttle,
        serviceDescription: 'Free shuttle',
        displayDuration: true,
    },
    [TAXI]: {
        shuttleIcon: IconCar,
        serviceDescription: 'Taxi/Rideshare',
        displayDuration: false,
    },
    [CURBSIDE_VALET]: {
        shuttleIcon: IconCurbsideDropoff,
        serviceDescription: 'Curbside dropoff',
        displayDuration: false,
    },
    [ON_DEMAND]: {
        shuttleIcon: IconShuttle,
        serviceDescription: 'Free shuttle on demand',
        displayDuration: false,
    },
    [PUBLIC_TRANSIT]: {
        shuttleIcon: IconPublicTransit,
        serviceDescription: 'Public transit accessible',
        displayDuration: false,
    },
};
const AirportSpotSummary = ({ data: { details: { code } = {}, shuttle: { fast_frequency: shuttleMin, slow_frequency: shuttleMax, type: shuttleType, } = {}, } = {}, amenities, walkingMeters, linearMeters, }) => {
    const { displayDuration, serviceDescription, shuttleIcon } = {
        ...SHUTTLE_CONFIG[DEFAULT],
        ...SHUTTLE_CONFIG[shuttleType],
    };
    const shuttleSpan = shuttleMin && shuttleMax
        ? `${shuttleMin} - ${shuttleMax}`
        : shuttleMin || shuttleMax || '';
    const shuttleSpanDescription = shuttleSpan && `every ${shuttleSpan} min`;
    const isSelfPark = amenities.find(item => item?.slug === 'self_park');
    const isValetPark = amenities.find(item => item?.slug === 'valet');
    const spotType = amenities.find(item => item?.slug === 'covered')
        ? 'Covered'
        : 'Uncovered';
    const Icon = shuttleIcon;
    // @ts-expect-error - parseDistance function needs to be typed first
    const distance = parseDistance({
        linearMeters,
        walkingMeters,
        format: 'long',
    });
    return (<div className="AirportSpotSummary">
            {shuttleType !== TAXI && (<div className="AirportSpotSummary-item">
                    <Icon />
                    <span className="AirportSpotSummary-description">
                        {serviceDescription}{' '}
                        {displayDuration ? shuttleSpanDescription : ''}
                    </span>
                </div>)}
            <div className="AirportSpotSummary-item">
                <IconMarker />
                <span className="AirportSpotSummary-description">
                    {distance} to {code}
                </span>
            </div>
            <div className="AirportSpotSummary-item">
                {spotType === 'Covered' ? (<IconCoveredSpot />) : (<IconUncoveredSpot />)}
                <span className="AirportSpotSummary-description">
                    {spotType} {isSelfPark ? 'self park' : ''}{' '}
                    {isValetPark ? 'valet' : ''}
                </span>
            </div>
        </div>);
};
export default AirportSpotSummary;
